import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

/* Common */
import { Icon } from '~/components/common';

/* Icons */
import iDealIcon from '~/../symbols/iDeal.svg';
import InfoIcon from '~/../symbols/info-circle.svg';

export default function ConversionFieldChoice(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {choices?.map((choice, choiceIndex) => {
                    return (
                        <Form.Check
                            key={choice.key}
                            className={`custom-control custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                            type={inputType}
                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                        >
                            <Form.Check.Input
                                type={inputType}
                                className="custom-control-input"
                                name={id}
                                value={choice.key}
                                {...{
                                    required,
                                    disabled,
                                }}
                                checked={value?.includes(choice.key)}
                                onChange={(e) => {
                                    updateChoice(choice, e.target.checked, () => {
                                        trigger(path);
                                    });
                                }}
                            />
                            <Form.Check.Label className={`custom-control-label ${(choice.iconType && choice.iconType === 'ideal') ? 'custom-control-label--ideal' : ''} `}>
                                <div className="custom-control-label__title d-flex">
                                    {(choice.tooltip && choice.tooltip !== '') && (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Tooltip id={`tooltip-${id}.choices.${choiceIndex}-${choice.key}`}>
                                                    {choice.tooltip}
                                                </Tooltip>
                                            }
                                        >
                                            <TooltipButton
                                                variant="none"
                                                className="mr-1 p-0 btn--tooltip"
                                            >
                                                <Icon
                                                    theme="base"
                                                    size={14}
                                                    url={InfoIcon?.url}
                                                    className={``}
                                                />
                                            </TooltipButton>
                                        </OverlayTrigger>
                                    )}
                                    <span dangerouslySetInnerHTML={{ __html: choice.label }} />
                                </div>
                                {choice?.['pay-off'] && (
                                    <span className="custom-control-label__pay-off">{choice?.['pay-off']}</span>
                                )}
                                {(choice.iconType && choice.iconType === 'ideal') && (
                                    <Icon
                                        theme="base"
                                        className={`icon icon--40 flex-shrink-0`}
                                        url={iDealIcon?.url}
                                    />
                                )}
                            </Form.Check.Label>
                        </Form.Check>
                    );
                })}
                {(field?.config?.info && field.config.info !== '') && (
                    <div className="d-flex align-items-center mt-4">
                        <Icon
                            theme="primary"
                            className={`icon icon--16 flex-shrink-0 mr-2`}
                            url={InfoIcon?.url}
                        />
                        <span className="text--sm">{ field.config.info }</span>
                    </div>
                )}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
